import { format } from 'date-fns';
import { RegistrationApplianceDetails } from '../../models/registration-appliance-details/registration-appliance-details.interface';

export const mockRegistrationApplianceDetails: RegistrationApplianceDetails = {
  brand: 'AEG',
  locatedAtMailingAddress: true,
  merchandiseInGoodWorkingOrder: true,
  modelNumber: '123',
  purchaseDate: format(new Date(), 'yyyy-MM-dd'),
  purchasePrice: '300',
  serialNumber: '456',
  type: 'CN',
};
